import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import qs from 'qs';
import verifyWithFacebookStore from '../../../stores/VerifyWithFacebookStore';
import userStore from '../../../stores/User';
import SocialLoginStore from '../../../stores/SocialLoginStore';
import registerWithFacebookCallbackStore from '../../../stores/RegisterWithFacebookCallback';
import csrfTokenStore from '../../../stores/CsrfToken';
import { Button, CircularProgress, Container, Stack, Typography } from '@mui/material';

function useQuery() {
  return new URLSearchParams(useLocation().hash.substring(1));
}

const FacebookCallback = () => {

  const history = useHistory();
  const query = useQuery();
  const user = userStore();
  const csrfToken = csrfTokenStore();
  const verifyStore = verifyWithFacebookStore();
  const facebookCallback = registerWithFacebookCallbackStore();
  const socialLogin = SocialLoginStore();

  useEffect(() => {
    const state = query.get("state");
    const token = query.get("access_token");
    if ( token && state === csrfToken.facebookState ) {
      verifyStore.verify(token);
    } else {
      verifyStore.setError(true, "Login failed");
    }
  }, [])

  useEffect(() => {
    if (verifyStore.result) {
      const { status } = verifyStore.result;
      if (status === "login_success") {
        user.setAccessToken(verifyStore.result.accessToken);
        user.setProfile(verifyStore.result.user);
        back();
      } else if (status === "verify_success") {
        goToRegisterPage();
      } else {
        verifyStore.setError(true, "Login failed");
      }
    }
  }, [verifyStore.result])

  const goToRegisterPage = () => {
    const { facebookId, email, firstname, lastname, accessToken } = verifyStore.result;
    facebookCallback.setData(
      facebookId,
      accessToken,
      email,
      firstname,
      lastname,
    );
    history.push('/register/facebook');
  }

  const back = () => {
    const targetPath = socialLogin.targetPath;
    history.push(targetPath || '/');
  }

  return (
    <Container
        sx={{ 
          height: '100vh',
          padding: '0px'
        }}
      >
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={1}
        sx={{ 
          height: '100vh',
          padding: '0px'
        }}
      >
        { verifyStore.isLoading && <CircularProgress /> }
        {
          verifyStore.hasError !== null && 
          <>
            <Typography variant="h3">{ verifyStore.errorMessage }</Typography>
            <Button
              variant="outlined" 
              className="my-4 normal-case text-base border-gray-400 text-black-normal text-lg font-medium"
              onClick={back}
            >
              Back
            </Button>
          </>
        }
        
      </Stack>
    </Container>
  );
}

export default FacebookCallback;